import * as React from 'react';
import SidemenuItem from '../sidemenu-item/sidemenu-item';
export default class SidemenuNav extends React.Component {
    static closeTree(branch) {
        return branch.map((item) => {
            if (!SidemenuNav.isDivider(item)) {
                return Object.assign(Object.assign({}, item), { children: item.children ? SidemenuNav.closeChildren(item.children) : undefined, open: false });
            }
            else {
                return item;
            }
        });
    }
    static closeChildren(branch) {
        return branch.map((item) => {
            return Object.assign(Object.assign({}, item), { children: item.children ? SidemenuNav.closeChildren(item.children) : undefined, open: false });
        });
    }
    static isDivider(el) {
        return Object.prototype.hasOwnProperty.call(el, 'type');
    }
    constructor(props) {
        super(props);
        this.getNextTree = (item, closedTree) => {
            return closedTree.map((treeItem) => {
                if (SidemenuNav.isDivider(treeItem)) {
                    return treeItem;
                }
                else {
                    return Object.assign(Object.assign({}, treeItem), { open: !!(treeItem.url === item.url && treeItem.label === item.label) });
                }
            });
        };
        this.handleToggle = (item) => {
            const closedTree = this.getClosedTree();
            const newTree = this.getNextTree(item, closedTree);
            if (!item.open) {
                if (typeof this.props.tree === 'undefined') {
                    this.setState({
                        tree: newTree,
                    });
                }
                if (this.props.onTreeChange) {
                    this.props.onTreeChange(newTree);
                }
            }
            else {
                if (typeof this.props.tree === 'undefined') {
                    this.setState({
                        tree: closedTree,
                    });
                }
                if (this.props.onTreeChange) {
                    this.props.onTreeChange(closedTree);
                }
            }
        };
        this.state = {
            tree: props.defaultTree || [],
        };
    }
    get tree() {
        return this.props.onTreeChange && typeof this.props.tree !== 'undefined' ? this.props.tree : this.state.tree;
    }
    renderItems(items) {
        return items.map((item, index) => {
            if (SidemenuNav.isDivider(item)) {
                return React.createElement("li", { key: index, className: "sidemenu__divider", role: "presentation" });
            }
            else {
                return React.createElement(SidemenuItem, Object.assign({ key: index }, item, { level: this.props.level, onToggle: this.handleToggle, subContainer: this.props.subContainer }));
            }
        });
    }
    getClosedTree() {
        return SidemenuNav.closeTree(this.tree);
    }
    BEM() {
        const classArray = ['sidemenu__nav'];
        if (typeof this.props.level !== 'undefined') {
            classArray.push('sidemenu__nav--level-' + this.props.level);
        }
        if (this.props.open) {
            classArray.push('is-open');
        }
        return classArray.join(' ');
    }
    render() {
        return (React.createElement("ul", { className: this.BEM(), ref: this.props.elementRef, role: this.props.behaviour === 'tabs' ? 'tablist' : undefined, "aria-labelledby": this.props['aria-labelledby'] }, this.renderItems(this.tree)));
    }
}
